export const ShapePreview = ({diameter = 70, color='black', handleColorClick, selected = false, label = '', code = ''}) => {

    return(
        <div
        style={{
          width: diameter,
          height: diameter,
          backgroundColor: "rgba(255, 255, 255, 0.5)", // Lichte doorzichtige achtergrond
         

          backgroundImage:
            `linear-gradient(90deg, ${color} 1px, transparent 1px),` +
            `linear-gradient(180deg,  ${color} 1px, transparent 1px)`,
          backgroundSize: "8px 8px", // Grootte van de vakken
          position: "relative",
        }}
        key={code}
        onClick={() => handleColorClick(code)}
        className={`rounded-full shadow-lg cursor-pointer border transition ${
          selected
            ? 'border-blue-600 border-4' 
            : 'border-gray-300'
        }`}
        title={label}
      ></div>
    )
}